<template>
  <modal
    class="new-editor-modal confirm-modal"
    name="timeless-confirm-modal"
    @before-open="handleBeforeOpen"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="40%"
    height="auto"
    style="z-index: 2001;"
  >
    <div id="modal-header"  class="action-modal">
      <div class="w-100 d-flex text-center justify-content-center">
        <p class="text-center">{{title}}</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('timeless-confirm-modal')"
              aria-label="Close"
      >
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
          </svg>
      </button>
    </div>
    <div id="modal-body" class="confirm-modal-body">
      <div class="h5" style="text-align: justify;">
        <p class="d-flex mt-2">ՈՒՇԱԴՐՈՒԹՅՈՒՆ !</p>
        <p class="d-flex mt-2">Հաստատել կոճակը սեղմելուց հետո գնման պատվերը և ստորագրված պայմանագիրն ուղարկվելու է ձեր կողմից ընտրված մասնակցին։</p>
        <p class="d-flex mt-2">Մասնակիցը պարտավոր է 1 աշխատանքային օրվա ընթացքում հաստատել պատվերը։ Նշված ժամկետում չհաստատելու դեպքում պատվերը համարվում է մերժված և մասնակցի նկատմամբ կիրառվում են Անժամկետ տենդերների կանոնակարգով նախատեսված սահմանափակումները։</p>
        <p class="d-flex mt-2">Մասնակցի կողմից պատվերը հաստատելու դեպքում գնորդի և վաճառողի միջև սկսում է գործել երկկողմանի հաստատված պայմանագիրը, որի շրջանակներում էլ իրականացվելու մատակարարումները և դրանց դիմաց վճարումները։</p>
        <br/>
      </div>
    </div>
    <div id="modal-footer">
      <button @click="$modal.hide('timeless-confirm-modal')" class="btn btn-light mr-3">
        <span>{{ declineBtnText }}</span>
      </button>
      <button @click="confirm" :disabled="loading" type="button" class="btn btn-primary">
        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        <span>{{ confirmBtnText }}</span>
      </button>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'TimelessConfirmModal',
    props: {
      confirmBtnText: {
        default: 'Հաստատել',
        type:  String
      },
      declineBtnText: {
        default: 'Չեղարկել',
        type: String
      }
    },
    data() {
      return {
        title: '',
        text: false,
        alertMsg: false,
        callback: null,
        loading: false
      }
    },
    methods: {
      handleBeforeOpen({ params }) {
        this.loading = false
        this.text = params.text
        this.title = params.title
        this.alertMsg = params.msg
        this.callback = params.callback
      },
      confirm() {
        this.loading = true;
        this.callback()
      }
    }
  }
</script>
<style>
  .confirm-modal .confirm-modal-body{
    height: fit-content !important;
    padding: 20px !important;
  }
  .confirm-modal-body *{
    font-size: 16px;
  }
  .tab {
      margin-left: 25px;
  }
</style>
<style scoped>

</style>
